import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import AchExceptionHomePage from "../containers/AchExceptionHomePage";
import HomePageAchExpanded from "../containers/HomePageAchExpanded";

import ExpandAllIcon from "@material-ui/icons/ExpandMoreOutlined";
import InfoIcon from "@material-ui/icons/InfoOutlined";

import CircularProgress from "@material-ui/core/CircularProgress";

import Tooltip from "@material-ui/core/Tooltip";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },
  redCell: {
    color: "red",
  },
  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },
  spacer: {
    flex: "1 1 100%",
  },

  table: {
    border: "1px solid black",
    margin: "20px",
    width: 700,
  },
  progress: {
    margin: theme.spacing.unit,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

class HomePageAch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      minutesLeft: 0,
      achAccounts: [],
      allAccounts: [],
      selectedAccountObject: {},
      selectedAccountIndex: 0,
      noExceptions: false,
      expanded: false,
      crtTime: "",
      searchInProgress: false,
      isPreferredAcctsOnly: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  onClosePopup(e) {
    this.setState({ selectedAccountIndex: 0 });
    this.setState({ expanded: false });
    this.setState({ isPreferredAcctsOnly: false });
    this.componentDidMount();
  }

  componentDidMount() {
    this.setState({ noExceptions: false });
    this.setState({ expanded: false });
    this.setState({ searchInProgress: true });
    fetch("on_exception_summary_request_ach", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
        } else {
          this.setState({ allAccounts: reply.achExceptions });
          this.setState({ achAccounts: reply.achExceptions });
          this.setState({ minutesLeft: reply.minutesLeft });
          if (reply.achExceptions.length === 0) {
            this.setState({ noExceptions: true });
          }
          var today = new Date();
          var time =
            ("0" + today.getHours()).slice(-2) +
            ":" +
            ("0" + today.getMinutes()).slice(-2);
          this.setState({ crtTime: time });
        }
        this.setState({ searchInProgress: false });
      })
      .catch((error) => {
        this.setState({ searchInProgress: false });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  setPreferredAcctsData(checked) {
    if (!checked) {
      this.setState({ achAccounts: this.state.allAccounts });
    } else {
      const myArray = this.state.allAccounts;
      const myFilter = this.props.prefs.accounts;

      const myArrayFiltered = myArray.filter((el) => {
        return myFilter.some((f) => {
          return f.transit === el.transit && f.accounts.includes(el.account);
        });
      });
      this.setState({
        achAccounts: myArrayFiltered,
      });
    }
  }

  handlePreferredAcctsOnly(e) {
    this.setState({ isPreferredAcctsOnly: e.target.checked });
    this.setPreferredAcctsData(e.target.checked);
  }

  handleSelectAccount(e, index) {
    this.setState({ selectedAccountIndex: index });
    let selectedObject;
    selectedObject = this.state.achAccounts[index - 1];
    this.setState({ selectedAccountObject: selectedObject });
  }

  handleUnselectAccount(e) {
    this.setState({ selectedAccountIndex: 0 });
    this.componentDidMount();
  }

  handleExpand(evenr) {
    this.setState({ expanded: true });
  }

  render() {
    const { classes } = this.props;
    let achItems = this.state.achAccounts;
    let { t } = this.props;
    return (
      <div>
        <div className={classes.tableWrapper}>
          {this.state.errorString.length > 0 && (
            <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
          )}
          {this.state.noExceptions &&
            this.state.minutesLeft >= 0 &&
            !this.state.searchInProgress && (
              <h3 style={{ color: "primary" }}>
                &nbsp;&nbsp;{t("noItemFound.label")}
              </h3>
            )}
          {this.state.noExceptions &&
            this.state.minutesLeft < 0 &&
            !this.state.searchInProgress && (
              <h4 style={{ color: "red" }}>
                &nbsp;&nbsp;{t("suspectReviewNotAvi.label")}
                <strong> {-this.state.minutesLeft} </strong>{" "}
                {t("minutesAs.label")} {this.state.crtTime}).
              </h4>
            )}
          {this.state.achAccounts.length === 0 &&
            this.state.errorString.length === 0 &&
            this.state.searchInProgress && (
              <div>
                <br></br>
                <CircularProgress className={classes.progress} />
              </div>
            )}
          {this.state.selectedAccountIndex !== 0 && (
            <AchExceptionHomePage
              secureToken={this.props.secureToken}
              viewOnly={this.props.viewOnly}
              history={this.props.history}
              account={this.state.selectedAccountObject}
              onClose={this.onClosePopup}
              minutesLeft={this.state.minutesLeft}
            />
          )}
          {this.state.errorString.length === 0 &&
            this.state.selectedAccountIndex === 0 && (
              <div>
                {this.state.achAccounts.length > 0 && this.state.expanded && (
                  <HomePageAchExpanded
                    secureToken={this.props.secureToken}
                    viewOnly={this.props.viewOnly}
                    history={this.props.history}
                    accounts={this.state.achAccounts}
                    onClose={this.onClosePopup}
                  />
                )}

                {!this.state.expanded && (
                  <div style={{ margin: 20 }}>
                    <Typography variant="h6" color="primary">
                      {t("achExceptions.label")}
                      <Tooltip
                        classes={{ tooltip: classes.customWidth }}
                        title={<div>{t("snapshot.tip")}</div>}
                      >
                        <InfoIcon color="primary" />
                      </Tooltip>
                      {this.state.achAccounts.length > 0 && (
                        <Button
                          color="primary"
                          style={{ position: "absolute", right: 20 }}
                          onClick={(event) => this.handleExpand(event)}
                        >
                          <ExpandAllIcon />
                          &nbsp;{t("expandAll.button")}
                        </Button>
                      )}
                    </Typography>
                    <Typography variant="body1" color="error">
                      {t("youHave.label")}
                      <strong> {this.state.minutesLeft} </strong>{" "}
                      {t("minuteLeft.label")}
                    </Typography>
                    <Paper>
                      &nbsp;&nbsp;
                      {this.state.minutesLeft > 0 && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.isPreferredAcctsOnly}
                              onChange={(event) =>
                                this.handlePreferredAcctsOnly(event)
                              }
                            />
                          }
                          label={t("includePreferredAcctsOnly.label")}
                        />
                      )}
                    </Paper>
                  </div>
                )}

                <div>
                  <Paper>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <Typography
                              variant="subtitle1"
                              color="primary"
                              style={{ fontWeight: 600 }}
                            >
                              {t("transit.header")}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography
                              variant="subtitle1"
                              color="primary"
                              style={{ fontWeight: 600 }}
                            >
                              {t("account.header")}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography
                              variant="subtitle1"
                              color="primary"
                              style={{ fontWeight: 600 }}
                            >
                              {t("numberExceptions.header")}{" "}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {achItems.map((item) => {
                          return (
                            <TableRow
                              hover
                              className={classes.tableRow}
                              onClick={(event) =>
                                this.handleSelectAccount(event, item.index)
                              }
                              key={item.index}
                              title={t("selectSuspect.label")}
                            >
                              <TableCell component="th" scope="row">
                                {item.transit}
                              </TableCell>
                              <TableCell>{item.account}</TableCell>
                              <TableCell>{item.numExceptions}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                      {this.state.achAccounts.length === 0 && (
                        <Typography variant="h12" color="primary">
                          {t("noData.label")}
                        </Typography>
                      )}
                    </Table>
                  </Paper>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(HomePageAch));
